import { Form, useSearchParams } from 'react-router'
import { Icon } from '#app/components/ui/icon.tsx'
import {
	InputGroup,
	InputGroupAddon,
	InputGroupButton,
	InputGroupInput,
} from '#app/components/ui/input-group.tsx'

export function GlobalSearch({
	placeholder = 'Search rentals and businesses...',
}: {
	placeholder?: string
}) {
	const [searchParams] = useSearchParams()
	const defaultValue = searchParams.get('q') ?? ''

	return (
		<Form method="GET" action="/search" role="search">
			<InputGroup className="bg-background h-12">
				<InputGroupInput
					name="q"
					defaultValue={defaultValue}
					placeholder={placeholder}
					aria-label="Search rentals and businesses"
					className="text-primary w-full"
				/>
				<InputGroupAddon align="inline-end">
					<InputGroupButton type="submit" variant="secondary" className="h-10">
						<Icon name="magnifying-glass" className="mr-2 size-4" />
						Search
					</InputGroupButton>
				</InputGroupAddon>
			</InputGroup>
		</Form>
	)
}
